$(function () {
	var tabContent = _.pick(AoPS.bd, "tab_content");
	var keepLearningModel = new AoPS.KeepLearning.Models.Index(tabContent);
	var keepLearningView = new AoPS.KeepLearning.Views.Index({
		model: keepLearningModel,
	});

	$("#main-content").append(keepLearningView.$el);
});
